function isBrowserOrWorkerEnvironment() {
  return (
    (typeof window !== "undefined" && typeof window.document !== "undefined") ||
    (typeof self !== "undefined" && typeof self.importScripts === "function")
  );
}

function getPathModule() {
  if (isBrowserOrWorkerEnvironment()) {
    const path = require("path-browserify");

    path.win32 = {
      sep: "\\",
    };
    return path;
  }
  return require("path");
}

module.exports = getPathModule();
